export var BogTransactionTypeEnum;
(function (BogTransactionTypeEnum) {
    BogTransactionTypeEnum["WITHDRAW"] = "WITHDRAW";
    BogTransactionTypeEnum["WITHDRAW_FEE"] = "WITHDRAW_FEE";
    BogTransactionTypeEnum["DEPOSIT"] = "DEPOSIT";
    BogTransactionTypeEnum["DEPOSIT_FEE"] = "DEPOSIT_FEE";
    BogTransactionTypeEnum["INTERNAL_EXCHANGE"] = "INTERNAL_EXCHANGE";
    BogTransactionTypeEnum["INTERNAL_TRANSFER"] = "INTERNAL_TRANSFER";
    BogTransactionTypeEnum["EXTERNAL_WITHDRAW"] = "EXTERNAL_WITHDRAW";
    BogTransactionTypeEnum["EXTERNAL_DEPOSIT"] = "EXTERNAL_DEPOSIT";
    BogTransactionTypeEnum["BANK_TRANSACTION"] = "BANK_TRANSACTION";
})(BogTransactionTypeEnum || (BogTransactionTypeEnum = {}));
//# sourceMappingURL=bog-transaction-type.enum.js.map